import { FileUploadConstantInputWrap } from '../../File'

import * as styles from './FileDragOverlay.module.css'

function FileDragOverlay({
  children,
  disabled,
  enableAttach,
  getInputProps,
  getRootProps,
}) {
  if (!enableAttach) {
    return <>{children}</>
  }

  return (
    <div {...getRootProps()} className={styles.wrapper}>
      <FileUploadConstantInputWrap
        disabled={disabled}
        getFileAttachInputProps={getInputProps}
      >
        {children}
      </FileUploadConstantInputWrap>
    </div>
  )
}

export default FileDragOverlay
